import { TableColumnsType } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "moment";

import { InsuranceOfferRequestsTableType } from "../../models";

export const insuranceOfferRequestsColumns =
  (): TableColumnsType<InsuranceOfferRequestsTableType> => {
    const columns: TableColumnsType<InsuranceOfferRequestsTableType> = [
      {
        title: "NASLOV",
        dataIndex: "name",
        render: (name) => <span className="text-primary">{name}</span>,
      },
      {
        title: "Naziv klijenta",
        dataIndex: "client",
        responsive: ["md"],
      },
      {
        title: "Status",
        dataIndex: "status",
        width: 120,
        responsive: ["sm"],
      },
      {
        title: "Odgovoreno",
        dataIndex: "answered",
        width: 120,
        align: "center",
        responsive: ["sm"],
        render: (answered) =>
          answered ? (
            <div className="space-x-2 text-base">
              <span>DA</span>
              <CheckCircleOutlined className="text-offer-blue" />
            </div>
          ) : (
            <div className="space-x-2 text-base">
              <span>NE</span>
              <CloseCircleOutlined className="text-ternary" />
            </div>
          ),
      },
      {
        title: "Datum zadnje izmjene",
        dataIndex: "updatedAt",
        width: 260,
        responsive: ["lg"],
        sorter: (a, b) => moment(a.updatedAt).diff(moment(b.updatedAt)),
      },
      {
        title: "Akcija",
        width: 220,
        render: (record) => (
          <Link
            to={`/insurance-offer-response/${record.key}`}
            className="inline-flex items-center justify-center rounded-sm bg-primary py-1 px-4 w-32 text-white font-medium"
          >
            <FileDoneOutlined className="text-base mr-2" />
            Detalji
          </Link>
        ),
      },
    ];

    return columns;
  };
